<template>
  <PageLayout title="Typografie">
    <v-row>
      <v-col cols="12" md="6">
        <div class="text-h1 font-weight-bold mb-6">
          Heading 1
        </div>
        <div class="text-h2 font-weight-bold mb-6">
          Heading 2
        </div>
        <div class="text-h3 font-weight-bold mb-6">
          Heading 3
        </div>
        <div class="text-h4 font-weight-bold mb-6">
          Heading 4
        </div>
        <div class="text-h5 font-weight-bold mb-6">
          Heading 5
        </div>
        <div class="text-h6 font-weight-bold mb-6">
          Heading 6
        </div>
        <div class="text-button font-weight-bold mb-6">
          Button
        </div>
        <div class="text-overline font-weight-bold mb-6">
          Overline
        </div>
        <div class="text-caption mb-6">
          Caption lorem ipsum
        </div>
      </v-col>
      <v-col cols="12" md="6">
        <p class="text-body-1">
          <strong>Body small</strong> Lorem ipsum dolor, sit amet consectetur
          adipisicing elit. Molestias impedit aliquam earum? Corporis
          consequatur nemo reiciendis optio. Neque nemo adipisci atque eveniet,
          tempore necessitatibus ducimus quas alias laboriosam veniam
          exercitationem!
        </p>
        <p>
          <strong>Body default</strong> Lorem ipsum dolor, sit amet consectetur
          adipisicing elit. Molestias impedit aliquam earum? Corporis
          consequatur nemo reiciendis optio. Neque nemo adipisci atque eveniet,
          tempore necessitatibus ducimus quas alias laboriosam veniam
          exercitationem!
        </p>
        <p class="text-body-2">
          <strong>Body large</strong>
          Lorem ipsum dolor, sit amet consectetur adipisicing elit. Molestias
          impedit aliquam earum? Corporis consequatur nemo reiciendis optio.
          Neque nemo adipisci atque eveniet, tempore necessitatibus ducimus quas
          alias laboriosam veniam exercitationem!
        </p>
      </v-col>
    </v-row>
  </PageLayout>
</template>

<script>
import PageLayout from "@/components/page/design-system/PageLayout.vue"

export default {
  components: {
    PageLayout,
  },
}
</script>
